module.exports = __webpack_public_path__ + "img/20210422091735418qa3.ad62f3c2.png";